"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoteModuleContent = void 0;
const react_1 = require("react");
const module_federation_1 = require("@invent/module-federation");
const useRemoteModuleContent = ({ url, scope, module }) => {
    const [data, setData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const fetchModuleContent = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                const moduleContent = yield (0, module_federation_1.loadComponent)(scope, module, url)();
                if (moduleContent) {
                    setData(moduleContent);
                }
            }
            catch (error) {
                if ((_a = window === null || window === void 0 ? void 0 : window.sharedHostGateway) === null || _a === void 0 ? void 0 : _a.logger) {
                    window.sharedHostGateway.logger.error('Empty content', {
                        message: 'Module content is empty.',
                        tags: {
                            origin: window.location.origin,
                            environment: process.env.NODE_ENV,
                            scope,
                            url
                        }
                    });
                }
            }
        });
        fetchModuleContent();
    }, [url, scope, module]);
    return { data };
};
exports.useRemoteModuleContent = useRemoteModuleContent;
exports.default = exports.useRemoteModuleContent;
